﻿export default class InformationButton {
    constructor() {
      this.id = 'moreInformationButton';
    }
  
    getHtml() {
      const styles = 'class="btn btn--yellow btn--width-100 btn--48-lg loading"';
      return `<button id="${this.id}" data-qa="get-more-information-button" ${styles}> Get More Information </button>`;
    }
  
    getNode() {
      return document.getElementById(this.id);
    }
  }
  